

import Joi from 'joi';
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./Contact.Validator.js"

class ContactAPI {


/*
undefinedPOST http://localhost:3000/contacts/create
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "name" : "Trịnh Viết Nam",
    "email":"trinhvietnambk@gmail.com",
    "phone":"0165 605 3482",
    "avatar":"Link avatar",
    "companyTaxCode":"798233922322",
    "position":"developer"
}


*/    


  create = async (data) => {
    const validator = Validator.VALIDATION_CONTACTS_CREATE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/contacts/create", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  detail = async (data) => {
    const validator = false;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.get(HOST + "/contacts/" + data.id, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };
/*


POST http://localhost:3000/contacts/list
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "companyTaxCode":"798233922322"
}


*/    


  list = async (data) => {
    const validator = Validator.VALIDATION_CONTACTS_LIST;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/contacts/list", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*


POST http://localhost:3000/contacts/delete
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "id":"299729139440"
}


*/    


  delete = async (data) => {
    const validator = Validator.VALIDATION_CONTACTS_DELETE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/contacts/delete", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


/*



*/
  update = async (data) => {
    const validator = Validator.VALIDATION_CONTACTS_UPDATE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/contacts/adminUpdate", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

}
export default new ContactAPI();



// WEBPACK FOOTER //
// ./src/services/contact/Contact.API.js